<template>
    <div class="md-layout">
        <div class="md-layout-item md-size-100">
            <md-card v-if="!isLoading">
                <md-card-header class="md-card-header-icon md-card-header-blue">
                    <div class="card-icon">
                        <md-icon>{{ icon }}</md-icon>
                    </div>
                    <h4 class="title"></h4>
                </md-card-header>
                <md-card-content>
                    <md-table
                        v-model="data"
                        class="paginated-table table-striped table-hover"
                    >
                        <md-table-toolbar>
                            <div class="md-toolbar-section-start">
                                <h1 class="md-title">{{ tableTitle }}</h1>
                                <LegendInfo
                                    bgColor="var(--green-400)"
                                    color="var(--green-900)"
                                    description="Aprovado"
                                />
                                <LegendInfo
                                    bgColor="var(--red-400)"
                                    color="var(--red-900)"
                                    description="Reprovado"
                                />
                                <LegendInfo
                                    bgColor="var(--yellow-400)"
                                    color="var(--yellow-900)"
                                    description="Pendente"
                                />
                                <md-button
                                    class="md-just-icon md-simple"
                                    @click.native="handleColumnsEdit()"
                                >
                                    <md-icon>settings</md-icon>
                                </md-button>
                            </div>
                        </md-table-toolbar>

                        <slot name="header"></slot>

                        <md-table-row>
                            <md-checkbox v-model="allSelected"></md-checkbox>
                            <md-table-head
                                v-for="(column, index) in visibleColumns"
                                :key="index"
                                @click.native="sortByColumn(column)"
                            >
                                <md-tooltip
                                    md-direction="top"
                                    v-if="tooltipHeader[column]"
                                >
                                    {{ tooltipHeader[column] }}
                                </md-tooltip>

                                <md-icon
                                    v-show="
                                        currentSort === column &&
                                            currentSortOrder === 'asc'
                                    "
                                >
                                    arrow_upward
                                </md-icon>
                                <md-icon
                                    v-show="
                                        currentSort === column &&
                                            currentSortOrder === 'desc'
                                    "
                                >
                                    arrow_downward
                                </md-icon>

                                {{ fieldNames[column] }}
                            </md-table-head>
                            <md-table-head
                                style="display:hidden"
                            ></md-table-head>
                        </md-table-row>
                        <template v-for="(value, index) in orderByCustom(data)">
                            <md-table-row
                                @mouseenter="actionVisible = index"
                                @mouseleave="actionVisible = null"
                                @click="toggle(index, value)"
                                :key="index"
                            >
                                <md-table-cell>
                                    <md-checkbox
                                        v-model="dataSelected"
                                        :value="index"
                                    ></md-checkbox>
                                </md-table-cell>

                                <md-table-cell
                                    v-for="column in visibleColumns"
                                    :key="column"
                                >
                                    <md-tooltip
                                        md-direction="top"
                                        style="width: 350px !important;"
                                        v-if="
                                            tooltipColumn.displayColumn ===
                                                column
                                        "
                                    >
                                        <span
                                            class="desc-tooltip"
                                            v-for="(tooltip,
                                            index) in showTooltipColumn(
                                                value.items,
                                                column
                                            )"
                                            :key="index"
                                        >
                                            <b>Qtd.</b>
                                            {{ tooltip.value }}:
                                            {{ tooltip.key }}
                                            <br />
                                        </span>
                                    </md-tooltip>

                                    <StatusBar
                                        v-if="column === 'status'"
                                        :typeBar="'progress'"
                                        :data="value.items"
                                    />

                                    <div v-if="column !== 'status'">
                                        {{ value[column] }}
                                    </div>
                                </md-table-cell>

                                <md-table-cell class="td-actions">
                                    <div
                                        id="td-actions"
                                        v-show="actionVisible == index"
                                    >
                                        <md-button
                                            @click="
                                                emitEvent(value, 'to submit')
                                            "
                                            class="md-just-icon md-primary md-simple"
                                        >
                                            <md-icon>check</md-icon>
                                        </md-button>
                                        <md-button
                                            @click="
                                                emitEvent(value, 'to reject')
                                            "
                                            class="md-just-icon md-danger md-simple"
                                        >
                                            <md-icon>close</md-icon>
                                        </md-button>
                                    </div>
                                </md-table-cell>
                            </md-table-row>

                            <master-detail
                                v-if="masterDetailShow"
                                :key="`detail-${index}`"
                                :content="value.detail"
                                :columnSize="visibleColumns.length + 2"
                                @submit="emitEvent"
                                @edit="emitEvent"
                                @reject="emitEvent"
                                @select="emitEvent"
                                v-show="opened.includes(index)"
                            />

                        </template>
                    </md-table>
                </md-card-content>
                <!--  pagination -->
                <md-card-actions md-alignment="space-between">
                    <slot name="pagination"></slot>
                </md-card-actions>
                <!-- ./pagination -->
            </md-card>
            <md-card v-else>
                <md-card-content>
                    <div class="text-center mt-2 pb-2">
                        <img
                            alt="Carregando..."
                            src="loader.svg"
                            style="width: 100px; height: 100px"
                        />
                    </div>
                </md-card-content>
            </md-card>
        </div>

        <modal v-if="columnsModal" @close="columnsCancel()" width="250px">
            <template slot="header">
                <h4 class="modal-title">Colunas disponíveis</h4>
                <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="columnsCancel()"
                >
                    <md-icon>clear</md-icon>
                </md-button>
            </template>

            <template slot="body">
                <div style="text-align: left">
                    <md-checkbox
                        v-for="column in Object.keys(columns)"
                        v-model="columns[column]"
                        :key="column"
                    >
                        {{ fieldNames[column] }}
                    </md-checkbox>
                </div>
            </template>

            <template slot="footer">
                <md-button class="md-primary" @click="columnsCancel()">
                    OK
                </md-button>
            </template>
        </modal>
    </div>
</template>

<script>
import { Modal } from '@/components'
import MasterDetail from '../MasterDetail'
import StatusBar from '@/components/Bars/StatusBar.vue'
import LegendInfo from '@/components/Legend/LegendInfo.vue'
import lodash from 'lodash'
import CustomSort from '@/mixins/CustomSort.vue'
import Utils from '@/utils'
import { mapActions } from 'vuex'

export default {
    //TODO: verificar hover na CALL da GenericTable
    name: 'generic-table',
    components: {
        Modal,
        MasterDetail,
        StatusBar,
        LegendInfo
    },

    props: {
        data: {
            required: true
        },
        columns: {
            required: true
        },
        fieldNames: {
            required: true
        },
        tableTitle: {
            type: String,
            required: true,
            default: 'Passar título com prop'
        },
        initialSort: {
            type: String,
            default: 'id'
        },
        isLoading: {
            type: [Array, String, Boolean, Number]
        },
        icon: {
            type: String,
            required: true,
            default: 'local_offer'
        },
        masterDetailShow: {
            type: Boolean,
            required: true,
            default: false
        },
        masterDetailTitle: {
            type: String,
            required: true,
            default: 'Passar título com prop'
        },
        tooltipHeader: {
            type: Object
        },
        tooltipColumn: {
            type: Object
        }
    },

    data() {
        return {
            currentSortOrder: 'desc',
            currentSort: this.initialSort,
            columnsModal: false,
            allSelected: false,
            columnNames: this.fieldNames,
            dataSelected: [],
            actionVisible: null,
            opened: [] //TODO: implementar paginação. Ficou faltando
        }
    },

    computed: {
        visibleColumns() {
            let columns = []
            Object.keys(this.columns).forEach(key => {
                if (this.columns[key]) columns.push(key)
            })
            return columns
        }
    },
    mixins: [CustomSort],
    methods: {

        showTooltipColumn(value, column) {
            const tooltip = lodash(value)
                .countBy(this.tooltipColumn.columnCount)
                .map((key, value) => ({ key, value }))
                .orderBy(['key'], ['desc'])
                .value()
            if (column === this.tooltipColumn.displayColumn) {
                return tooltip
            }
        },
        handleColumnsEdit() {
            this.columnsModal = true
        },

        columnsCancel() {
            this.columnsModal = false
        },

        emitSelectedItems(items) {
            let selectedItems = items.map(item => {
                return _.omit(item, 'buttons', 'columns')
            })
            this.$emit('select', selectedItems)
        },

        sortByColumn(column) {
            if (column === this.currentSort) {
                this.currentSortOrder =
                    this.currentSortOrder === 'asc' ? 'desc' : 'asc'
            }
            this.currentSort = column
        },

        toggle(id, data) {
            Utils.toggle(id, this.opened)
            let isToggled = this.opened.includes(id)

            if (isToggled) {
                this.wrapperValue(id, data)
            }
        },
        wrapperValue(index, data) {
            this.$emit('update:dataTable', {
                index,
                data
            })
        },

        emitEvent(content, action) {
            if (content.items) {
                const items = content.items.map(item => {
                    return _.omit(item, 'buttons', 'columns')
                })

                content = { ...content, items }
            }

            if (action) {
                const event =
                    action === 'to submit'
                        ? 'submitDetail'
                        : action === 'to edit'
                            ? 'editDetail'
                            : 'rejectDetail'

                this.$emit(event, content, action)
            } else {
                this.$emit('selectDetail', content)

            }
        }
    }
}
</script>

<style scoped>
#td-actions {
    height: 65px;
}

.desc-tooltip {
    font-size: 0.8rem;
    width: 400px;
}
</style>
